import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../components/buttons';
import { checkFieldExistence, clearFieldErrorArray } from '../../../../modules/AppConfig/actions';
import { change, Field, FieldArray, formValueSelector, reduxForm } from 'redux-form';
import { isInteger, isValidNameWithSpace, renderTextField, normalizeDecimal } from '../../../../components/reduxFields';
import { asyncValidateAction, getRoundingRuleById, saveRoundingRule } from './actions/RoundingRuleActions';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import React from 'react';
import _ from 'lodash';
import { MODULE } from './constants/ApiConstants';

const validate = (values) => {
  const error = {};
  if (!values.ruleName || values.ruleName.trim() === '') {
    error.ruleName = 'Please enter rule name';
  }
  const membersArrayErrors = [];
  if (values.roundingRuleDetail && values.roundingRuleDetail.length > 0) {
    for (let i = 0; i < values.roundingRuleDetail.length; i++) {
      const memberErrors = {};

      if (values.roundingRuleDetail[i].startRange && values.roundingRuleDetail[i].endRange) {
        if (parseFloat(values.roundingRuleDetail[i].endRange) <= parseFloat(values.roundingRuleDetail[i].startRange)) {
          memberErrors.endRange = 'End range must be greater than start range';
          membersArrayErrors[i] = memberErrors;
        }
      }
      if (!(parseFloat(values.roundingRuleDetail[i].startRange) >= 0)) {
        memberErrors.startRange = 'Please enter a start range';
        membersArrayErrors[i] = memberErrors;
      }
      if (i > 0 && parseFloat(values.roundingRuleDetail[i].startRange) <= parseFloat(values.roundingRuleDetail[i - 1].endRange)) {
        memberErrors.startRange = 'Start range must be greater than previous end range';
        membersArrayErrors[i] = memberErrors;
      }
      if (!(parseFloat(values.roundingRuleDetail[i].endRange) >= 0)) {
        memberErrors.endRange = 'Please enter a end range';
        membersArrayErrors[i] = memberErrors;
      }
    //   return memberErrors;
    }

    if (membersArrayErrors.length) {
      error.roundingRuleDetail = membersArrayErrors;
    }
  }
  return error;
};


const asyncValidate = (values, dispatch, props) => {
  let postData = {
    'labelName': 'Rule name',
    'tableName': 'MASTER_ROUNDINGRULE_ruleName'.toUpperCase(),
    'value': values.ruleName,
    'colmnName': 'ruleName'.toUpperCase(),
    'id': values.id,
  };
  return new Promise((resolve, reject) => {
    if (!values.ruleName) {
      reject({ ruleName: 'Please enter rule name' });
    } else {
      asyncValidateAction(postData, resolve, reject, props.access_token);
    }
  });
};

class RoundingRuleModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = ({
      roundingRuleObj: (this.props.roundingRuleObj ? this.props.roundingRuleObj : null),
      open: true,
      rrule: new Array(1).fill({ StartRange: null, EndRange: null, Unit: null }),
      ruleID: (this.props.roundingRuleObj ? this.props.roundingRuleObj.id : 0),
      totalDataLength: 1,
      deletedRows: [],
    });
    this.addRow = this.addRow.bind(this);
    this.removeRow = this.removeRow.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  componentWillMount() {
    // if (this.state.ruleID) {
    this.props.getRoundingRuleById(this.state.ruleID);
    // }
  }

  componentWillReceiveProps(nextProps) {
    // console.log('nextProps---', nextProps);
    if (nextProps.initialValues && this.props.initialValues !== nextProps.initialValues) {
      if (nextProps.initialValues.roundingRuleDetail && nextProps.initialValues.roundingRuleDetail.length !== this.props.initialValues.roundingRuleDetail.length) {
        this.setState({
          totalDataLength: nextProps.initialValues.roundingRuleDetail.length,
        });
      }
    }

    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };

  }

  handleOpen = () => {
    this.setState({ open: true,
    });
  };

  handleClose = () => {
    if (this.state.open) {
      this.setState({
        open: false });
      this.props.clearFieldErrorArray();
      this.props.closeDialog();
    }
  };


  /** *******************     Input field exist check        ***********************/
  checkFieldDataExistence = (input, value, labelName) => {
    this.setState({ serviceCodeExistsErrorMessage: null });
    if (value.length > 0) {
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': (this.props.initialValues && this.props.initialValues.id) ? this.props.initialValues.id : 0,
      };
      this.props.checkFieldExistence(postData);
    }
  };
  /** *****   End Input field exist check    **********/

  handleSave=(formProps) => {
    // if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
    //   return null;
    // }

    let formObj = { ...formProps };

    if (this.state.deletedRows.length > 0) {
      for (let i = 0; i < this.state.deletedRows.length; i++) {
        _.update(this.state.deletedRows, `${i}.isDeleted`, function(n) {
          return true;
        });
      }
      this.state.deletedRows.forEach((item, index) => {
        formObj.roundingRuleDetail.push(item);
      });
    }

    let filterObjs = formObj.roundingRuleDetail.filter((item) => {
      if (item.id) {
        return item;
      } else {
        if (!item.isDeleted) {
          return item;
        }
      }
    });

    formObj.roundingRuleDetail = filterObjs;

    formObj.id = this.state.ruleID;
    formObj.ruleName = formObj.ruleName.trim();
    // this.props.clearFieldErrorArray();
    this.props.saveRoundingRule(formObj);
    this.setState({
      open: false });
    this.props.closeDialog();
  };

  addRow = () => {};
  removeRow = (i) => {};
  renderTemplate = ({ fields }) => {
    this.removeRow = (i, e) => {

      let deletedRows = this.state.deletedRows;
      if (this.state.roundingRuleObj) {
        deletedRows.push(this.props.roundingRuleDetail[i]);
      }
      fields.remove(i);
      let totalDataLength = this.state.totalDataLength;
      totalDataLength = totalDataLength - 1;

      //* @desc To searialize data - start (* - you may comment this code for previous funtionality)
      if (i > 0) {
        // if (i === totalDataLength) {
        // } else {
        //   for (let j = i; j < totalDataLength; j ++) {

        //     let nextStartRange = parseFloat(this.props.roundingRuleDetail[j - 1].endRange) + 0.01;
        //     let nextEndRange = parseFloat(this.props.roundingRuleDetail[j - 1].endRange) + 0.01 + (parseFloat(this.props.roundingRuleDetail[j - 1].endRange) - parseFloat(this.props.roundingRuleDetail[j - 1].startRange));
        //     let nextNoOfUnits = parseInt(this.props.roundingRuleDetail[ j - 1].unit, 10) + 1;

        //     this.props.dispatch(change('RoundingRuleModalForm', `roundingRuleDetail[${j}].startRange`, parseFloat(nextStartRange || 0).toFixed(2)));
        //     this.props.dispatch(change('RoundingRuleModalForm', `roundingRuleDetail[${j}].endRange`, parseFloat(nextEndRange || 0).toFixed(2)));
        //     this.props.dispatch(change('RoundingRuleModalForm', `roundingRuleDetail[${j}].unit`, nextNoOfUnits));
        //   }
        // }
      } else {
        let nextStartRange = parseFloat(this.props.roundingRuleDetail[i + 1].startRange);
        let nextEndRange = parseFloat(this.props.roundingRuleDetail[i + 1].endRange);
        let nextNoOfUnits = parseInt(this.props.roundingRuleDetail[ i + 1].unit, 10);
        this.props.dispatch(change('RoundingRuleModalForm', `roundingRuleDetail[${i}].startRange`, parseFloat(nextStartRange || 0).toFixed(2)));
        this.props.dispatch(change('RoundingRuleModalForm', `roundingRuleDetail[${i}].endRange`, parseFloat(nextEndRange || 0).toFixed(2)));
        this.props.dispatch(change('RoundingRuleModalForm', `roundingRuleDetail[${i}].unit`, nextNoOfUnits));
      }
      //* @desc To searialize data - End
      this.setState({
        deletedRows: deletedRows,
        totalDataLength: totalDataLength,
      });
    };

    this.addRow = (e) => {

      ///////
      let obj = this.props.roundingRuleDetail[this.props.roundingRuleDetail.length - 1];
      let startRange = parseFloat(parseFloat(obj.endRange) + 0.01);
      let endRange = parseFloat(parseFloat(obj.endRange) + 1);
      let unit = parseFloat(parseFloat(obj.unit) + 1);
      ///////


      fields.push({ startRange, endRange, unit });
      let totalDataLength = this.state.totalDataLength;
      totalDataLength = totalDataLength + 1;
      this.setState({
        totalDataLength: totalDataLength,
      }, () => {

      });

      // let nextStartRange = parseFloat(this.props.roundingRuleDetail[totalDataLength - 2].endRange) + 0.01;
      // let nextEndRange = parseFloat(this.props.roundingRuleDetail[totalDataLength - 2].endRange) + 0.01 + (parseFloat(this.props.roundingRuleDetail[totalDataLength - 2].endRange) - parseFloat(this.props.roundingRuleDetail[totalDataLength - 2].startRange));
      // let nextNoOfUnits = parseInt(this.props.roundingRuleDetail[totalDataLength - 2].unit, 10) + 1;

      // this.props.dispatch(change('RoundingRuleModalForm', `roundingRuleDetail[${totalDataLength - 1}].startRange`, parseFloat(nextStartRange || 0).toFixed(2)));
      // this.props.dispatch(change('RoundingRuleModalForm', `roundingRuleDetail[${totalDataLength - 1}].endRange`, parseFloat(nextEndRange || 0).toFixed(2)));
      // this.props.dispatch(change('RoundingRuleModalForm', `roundingRuleDetail[${totalDataLength - 1}].unit`, nextNoOfUnits));
    };

    return (
      <div>
        { fields.map((roundingRuleDetail, index) => {
          return (<div className ="row" key = {index}>
            <div className="col-sm-4 require">
              <Field
                name={`${roundingRuleDetail}.startRange`}
                fullWidth={true}
                floatingLabelText="Start Range"
                component={renderTextField}
                normalize = {normalizeDecimal}
              />
            </div>
            <div className="col-sm-4 require">
              <Field
                name={`${roundingRuleDetail}.endRange`}
                fullWidth={true}
                floatingLabelText="End Range"
                component={renderTextField}
                normalize = {normalizeDecimal}
              />
            </div>
            <div className="col-sm-4 pdl-40">
              <Field
                name={`${roundingRuleDetail}.unit`}
                fullWidth={true}
                floatingLabelText="Unit (s)"
                component={renderTextField}
                normalize = {isInteger}
              />

              { (fields.length - 1) === index ?
                <div>
                  {fields.length > 1 ?
                    <button className="additem removeitem"
                      onClick={this.removeRow.bind(this, index)} type="button" title="Remove Row">
                      <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                    </button>
                    : ''}
                  <button className="additem" onClick={(e) => this.addRow()} type="button" title="Add row">
                    <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                  </button>
                </div>
                :
                <div>
                  <button className="additem"
                    onClick={this.removeRow.bind(this, index)} type="button" title="Remove Row">
                    <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                  </button>
                </div>
              }
            </div>
          </div>
          );
        }
        )
        }
      </div>
    );
  };

  render() {
    const { handleSubmit, loading } = this.props;
    let submitButton = this.props.saving ? <SubmitButtonModalDisabled label="Saving"/> :
      <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.handleSave)} />;
    const actions = [
      <CancelButton className="mr-15" onTouchTap={this.handleClose}/>,
      submitButton,
    ];
    if (loading === true) {
      return false;
    }
    return (<div>
      { this.handleOpen ?
        <Dialog
          className="custom_modal"
          title={(this.state.roundingRuleObj) ? 'Edit Rounding Rule' : 'Add Rounding Rule'}
          modal={false}
          actions={actions}
          open={this.state.open}
          autoScrollBodyContent={true}
        >
          <div className="row">
            <div className="col-sm-12">
              <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSave)}>
                <div className="row">
                  <div className ="col-sm-12 col-md-12 require">
                    <Field
                      autoFocus={true}
                      name='ruleName'
                      fullWidth={true}
                      floatingLabelText="Rule Name"
                      // onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Rule name')}
                      // customError={displayCustomError('RULENAME', this.props.fieldError)}
                      maxLength = "50"
                      normalize = {isValidNameWithSpace}
                      component={renderTextField}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className ="col-sm-12">
                    <FieldArray name="roundingRuleDetail" component={this.renderTemplate} />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Dialog> : null}</div>);
  }
}

RoundingRuleModal = reduxForm({
  form: 'RoundingRuleModalForm',
  validate,
  asyncValidate,
  asyncBlurFields: ['ruleName'],
  enableReinitialize: true,
})(RoundingRuleModal);
const selector = formValueSelector('RoundingRuleModalForm');
function mapStateToProps(state, ownProps) {
  let roundingRuleDetail = [];
  if (state.rounding_rule.get_rounding_rule_details && state.rounding_rule.get_rounding_rule_details.data && state.rounding_rule.get_rounding_rule_details.data.roundingRuleDetail) {
    roundingRuleDetail = state.rounding_rule.get_rounding_rule_details.data.roundingRuleDetail;
  } else {
    roundingRuleDetail = [{ 'startRange': parseFloat(0.01).toFixed(2), 'endRange': parseFloat(1.00).toFixed(2),
      'unit': 1 }];
  }

  return {
    loading: state.rounding_rule.loading,
    saving: state.rounding_rule.saving,
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    roundingRuleDetail: selector(state, 'roundingRuleDetail'),
    access_token: state.login.access_token,
    initialValues: {
      id: (ownProps.roundingRuleObj && ownProps.roundingRuleObj.id) || 0,
      roundingRuleDetail: roundingRuleDetail,
      ruleName: ownProps && ownProps.roundingRuleObj && ownProps.roundingRuleObj.ruleName ? ownProps.roundingRuleObj.ruleName : '',
    },
  };
}

export default connect(mapStateToProps, { checkFieldExistence, clearFieldErrorArray, saveRoundingRule, getRoundingRuleById, asyncValidateAction })(RoundingRuleModal);



// WEBPACK FOOTER //
// ./src/modules/Masters/components/rounding-rule/rounding-rule-modal.js